
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "5 raisons pour faire appel à une agence de graphisme",
    description:
      "Découvrez comment une agence de graphisme peut transformer votre communication visuelle. Profitez de l'expertise d'ALEO pour booster votre image de marque.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
